import { get } from "lodash";
import { Box, Divider, H5 } from "orcs-design-system";
import React from "react";
import PropTypes from "prop-types";
import PersonItem from "src/components/Person/PersonItem";
import { useAuth0 } from "src/contexts/auth0Provider";
import { useUserPerson } from "src/contexts/global/GlobalContext";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import { copywriting } from "src/pages/PersonDetailPage/PersonDetailPage.config";
import { getSupplyBadgeGroups } from "src/util/group";
import { isValidPerson } from "src/util/person";

const ReportsTo = ({ person }) => {
  const { user } = useAuth0();
  const userPerson = useUserPerson();
  const workspace = useWorkspace();
  const groupTypes = get(workspace, "config.groupTypes");
  const featureFlags = get(workspace, "config.featureFlags", {});

  const hideDirectReports = get(
    workspace,
    "config.allocation.hideDirectReports"
  );
  const managingPerson = get(person, "managedBy");
  const showReportsTo = isValidPerson(managingPerson) && !hideDirectReports;

  if (!showReportsTo) {
    return null;
  }
  return (
    <>
      <Divider mt="l" mb="l" dash />
      <Box>
        <H5 sizing="small" weight="bold" color="greyDark" uppercase>
          {copywriting.REPORTS_TO}
        </H5>
        <PersonItem
          reportsTo
          isDisplayActionsButton={false}
          person={managingPerson}
          badgeGroups={getSupplyBadgeGroups({
            person: managingPerson,
            groupTypes,
          })}
          groupTypes={groupTypes}
          user={user}
          workspace={workspace}
          featureFlags={featureFlags}
          userPerson={userPerson}
          isLastItem
        />
      </Box>
    </>
  );
};

ReportsTo.propTypes = {
  person: PropTypes.object,
};

export default React.memo(ReportsTo);
